export default __webpack_public_path__ + "static/media/kormoran.076a9817.jpg";